<template>
  <div>
    <div class="container" v-if="project">
      <div class="py-md-5 text-center">
        <h1 class="title">{{ project.name }}</h1>
        <p v-if="project.tagline">
          {{ project.tagline }}
        </p>
      </div>

      <div v-html="project.case_study"></div>

      <hr class="space space-sm">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'case-study',
  props: ['id'],
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.homeProjects,
      clients: state => state.clients.clients
    }),
    project () {
      return this.projects.find((e) => parseInt(e.id) === parseInt(this.id))
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('LOAD_HOME_PROJECTS')
  }
}
</script>
